<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Theatre experienced the second highest growth in revenue by 86.7% (from $78.5m in 2018 to $146.6m in 2019) despite a moderate growth in attendance by 7.0% (from 1.4m in 2018 to 1.5m in 2019). The growth in revenue was primarily attributed to the increase in average ticket prices by 69.1% (from $63.91 in 2018 to $108.07 in 2019). This is the highest recorded revenue and average ticket price in this category since 2004.</p>
          <p>Top events in this category in 2019 were <em>Harry Potter and the Cursed Child</em>, <em>The Lady in the Van</em>, <em>Cat on a Hot Tin Roof</em>, <em>Shakespeare in Love</em> and <em>The Beauty Queen of Leenane</em>.</p>
          <p>In 2020, the category experienced a significant decline in revenue (by 72.8% to $39.9m from 2019) and a decline in attendance (by 72.4% to 0.4m), due to COVID-19 restrictions and limited touring activity of AMPAG / NPAP companies. The average ticket price declined by 2.7% (to $105.14), which further contributed to the decline in revenue. </p>
          <p>Top events in this category in 2020 were <em>Harry Potter and the Cursed Child</em>, <em>Home</em>, <em>I'm Darling</em>, <em>The Deep Blue Sea</em> and <em>A Christmas Carol</em>.</p>
        </div>
        <div class="sixcol last">
          <p>35.4% of the revenue and 60.0% of the attendance in 2019 and 35.2% of the revenue and 54.9% of the attendance in 2020 were generated through performances by AMPAG / NPAP companies: Sydney Theatre Company, Melbourne Theatre Company, Belvoir, Bell Shakespeare, Black Swan State Theatre Company, Malthouse Theatre, Queensland Theatre and the State Theatre Company of South Australia.</p>
          <p>Victoria and NSW accounted for the majority of revenue and attendance in 2019 and 2020. In 2019, Victoria and NSW had a combined 87.5% of market share in revenue (69.0% and 18.5% respectively) and a combined 73.1% of market share in attendance (42.8% and 30.3% respectively) in 2019. In 2020, the states had a combined 87.3% of market share in revenue (60.0% and 27.3% respectively) and a combined 78.2% of market share in attendance (38.4% and 39.8% respectively). </p>
          <p>In 2019, Victoria witnessed the highest y-o-y increase in revenue (287.0%), primarily due to the opening of <em>Harry Potter and the Cursed Child</em>, while WA witnessed the highest y-o-y increase in attendance (165.9%). In 2020, all states and territories witnessed a significant decline in revenue and attendance.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Medea</em>, A Black Swan State Theatre Company of WA collaboration with WA Youth Theatre Company, Photo Credit: Philip Gostelow</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y.toFixed(3) + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [89.418, 73.989, 143.564, 117.383, 80.477, 64.441, 60.151, 65.881, 82.973, 119.647, 99.715, 56.832, 79.584, 64.218, 78.505, 146.562, 39.867],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [2.203, 2.118, 3.828, 2.505, 1.944, 1.603, 1.354, 1.381, 1.601, 1.842, 1.504, 1.135, 1.352, 1.458, 1.43, 1.531, 0.422],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 18.5],
            ["VIC", 69.0],
            ["QLD", 4.0],
            ["WA", 4.4],
            ["SA", 2.4],
            ["ACT", 1.3],
            ["TAS", 0.2],
            ["NT", 0.1]
          ],
          attendance: [
            ["NSW", 30.3],
            ["VIC", 42.8],
            ["QLD", 8.6],
            ["WA", 10.6],
            ["SA", 4.3],
            ["ACT", 2.3],
            ["TAS", 0.9],
            ["NT", 0.2]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 27.3],
            ["VIC", 60.0],
            ["QLD", 6.6],
            ["WA", 2.6],
            ["SA", 2.6],
            ["ACT", 0.4],
            ["TAS", 0.5],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 39.8],
            ["VIC", 38.4],
            ["QLD", 12.0],
            ["WA", 3.5],
            ["SA", 4.8],
            ["ACT", 0.7],
            ["TAS", 0.7],
            ["NT", 0.1]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/Medea,-A-Black-Swan-State-Theatre-Company-of-WA-collaboration-with-WA-Youth-Theatre-Company,-Philip-Gostelow-35_SFW.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
